
<div class="global-overlay" :class="{ 'global-dark': darkTransparent }" @wheel="onChange" @click="onChange">
  <slot></slot>
</div>
